

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicFoodsListComponent } from './public-foods-list/public-foods-list.component';
import { PublicFoodsComponent } from './public-foods.component';

const routes: Routes = [{
  path: '',
  component: PublicFoodsComponent,
  children: [
    {
      path: '',
      redirectTo: 'list',
      pathMatch: 'full',
    },
    {
      path: 'list',
      component: PublicFoodsListComponent,
    },
    // {
    //  path: 'add',
    //  component: SubscriptionComponent,
    //  resolve: { subscriptionData: SubscriptionFormResolver },
    // },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class PublicFoodsRoutingModule {

}
